// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"aac99799","128":"bc234757","532":"8746a732","866":"3f40db2d","945":"7c7180ec"}[chunkId] + ".chunk.css";
};